<script setup lang="ts">
import {
  AlertDialog, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { useModuleRecovery } from '@/lib/module-recovery';

const { open, dismiss, reload } = useModuleRecovery();
</script>

<template>
  <AlertDialog :open="open" @update:open="!$event && dismiss()">
    <AlertDialogContent class="sm:max-w-[440px]">
      <AlertDialogHeader>
        <AlertDialogTitle>Не удалось загрузить раздел</AlertDialogTitle>
        <AlertDialogDescription>
          Возможно, приложение обновилось или соединение прервалось.
          Проверьте подключение и обновите страницу. Перед обновлением
          сохраните незавершённые изменения.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel @click="dismiss">Остаться здесь</AlertDialogCancel>
        <Button @click="reload">Обновить страницу</Button>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
</template>
